const ProFacets = [
	{ value: 'ABRAMUS' },
	{ value: 'AKM' },
	{ value: 'APRA' },
	{ value: 'ASCAP' },
	{ value: 'BMI' },
	{ value: 'BUMA' },
	{ value: 'CASH' },
	{ value: 'GEMA' },
	{ value: 'GMR' },
	{ value: 'IMRO' },
	{ value: 'MCSC' },
	{ value: 'PRS' },
	{ value: 'PRS/BMI' },
	{ value: 'SACEM' },
	{ value: 'SAMRO' },
	{ value: 'SESAC' },
	{ value: 'SGAE' },
	{ value: 'SOCAN' },
	{ value: 'SOCAN/GMR' },
	{ value: 'STIM' },
	{ value: 'TEOSTO' },
	{ value: 'TONO' },
	{ value: 'UBC' },
]
export default ProFacets
